import throttle from 'lodash/throttle';

import {useEffect, useMemo} from 'react';
import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNilOrEmpty} from 'ramda-adjunct';

import {chatAgentApi} from '@dms/api/core';

import {sendEvent, Type} from '@chat/shared/graphql';

import {useGetCurrentChatUser} from '../hooks/useGetCurrentChatUser';
import {MessageFormValues} from '../types/MessageFormValues';
import {chatAppSync} from '../utils/chatAppSync';

interface TypingFlareProps {
  formApi: UseFormReturn<MessageFormValues>;
  conversationId: string;
}

export function TypingFlare(props: TypingFlareProps) {
  const {formApi, conversationId} = props;

  const currentUserInConversation = useGetCurrentChatUser({conversationId});
  const customerUserId = currentUserInConversation?.id || '';

  const conversationQuery = chatAgentApi.useGetAgentConversationQuery(
    {
      conversationId,
    },
    {skip: isNilOrEmpty(conversationId)}
  );

  const tenantId = conversationQuery.data?.tenantId;

  const sendTypingEvent = useMemo(
    () =>
      throttle(
        (conversationId: string, customerUserId: string, tenantId: string) => {
          chatAppSync.graphql({
            query: sendEvent,
            variables: {
              conversationId,
              id: crypto.randomUUID(),
              tenantId,
              type: Type.TYPING,
              userId: customerUserId,
            },
          });
        },
        5_000,
        {trailing: false}
      ),
    []
  );

  const message = useWatch({control: formApi.control, name: 'message'});

  useEffect(() => {
    if (!!message && !!customerUserId && !!tenantId) {
      sendTypingEvent(conversationId, customerUserId, tenantId);
    }
  }, [sendTypingEvent, message, customerUserId, conversationId, tenantId]);

  return null;
}
